import { render, staticRenderFns } from "./QuotesTab.vue?vue&type=template&id=31b96836&scoped=true&"
import script from "./QuotesTab.vue?vue&type=script&lang=ts&"
export * from "./QuotesTab.vue?vue&type=script&lang=ts&"
import style0 from "./QuotesTab.vue?vue&type=style&index=0&id=31b96836&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b96836",
  null
  
)

export default component.exports